import { OPENAI_ADS_PIXEL_ID, isOpenAiAdsHost, openAiEventData } from './openai-ads';
type Queue = ((...args: unknown[]) => void) & { q?: unknown[][] };
declare global { interface Window { oaiq?: Queue } }

export function syncOpenAiConsent(allowed: boolean) {
  if (!isOpenAiAdsHost(window.location.hostname)) return;
  if (!allowed) {
    window.oaiq?.('consent', false);
    try {
      const snapshot = JSON.parse(window.localStorage.getItem('printen_attribution') || '{}');
      if (snapshot.oppref || snapshot.obref) { delete snapshot.oppref; delete snapshot.obref; window.localStorage.setItem('printen_attribution', JSON.stringify(snapshot)); }
    } catch { /* Storage may be blocked. */ }
    // Remove SDK click attribution after withdrawal as well as our snapshot.
    for (const domain of ['', '; domain=.printen.eu']) {
      for (const name of ['__oppref', '__obref']) document.cookie = `${name}=; path=/; max-age=0; Secure; SameSite=Lax${domain}`;
    }
    return;
  }
  if (!window.oaiq) {
    const queue: Queue = (...args) => { queue.q!.push(args); };
    queue.q = [];
    window.oaiq = queue;
    queue('consent', false);
    queue('init', { pixelId: OPENAI_ADS_PIXEL_ID });
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';
    script.dataset.printenOpenai = OPENAI_ADS_PIXEL_ID;
    document.head.appendChild(script);
  }
  window.oaiq('consent', true);
}

export function trackOpenAiEvent(name: string, payload: Record<string, unknown>, eventId: string) {
  if (!isOpenAiAdsHost(window.location.hostname) || !window.oaiq) return;
  const event = ({ page_view: 'page_viewed', view_item: 'contents_viewed', add_to_cart: 'items_added', begin_checkout: 'checkout_started', purchase: 'order_created' } as Record<string, string>)[name];
  if (!event || payload.openAiConsentAtCapture === false) return;
  // Server-rendered paid confirmation is the only purchase authority. Consent
  // denied at checkout must never replay as a historical OpenAI purchase.
  if (name === 'purchase' && payload.openAiPurchaseAllowed !== true) return;
  const data = openAiEventData(name === 'purchase' ? payload.openAiRevenue : payload.value, payload.currency || 'EUR', payload.contents);
  if (!data || (name === 'purchase' && data.amount === undefined)) return;
  window.oaiq('measure', event, data, { event_id: eventId });
}
